import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import './index.css';
import getLocation from './utils/getLocation';

const target = document.getElementById('root');
if (target) { 
  getLocation();
  ReactDOM.render( <App />,  target );
}